/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RecentHotel
 */
export interface RecentHotel {
    /**
     *
     * @type {number}
     * @memberof RecentHotel
     */
    propertyId: number;
    /**
     *
     * @type {string}
     * @memberof RecentHotel
     */
    propertyName: string;
    /**
     *
     * @type {string}
     * @memberof RecentHotel
     */
    propertyAddress?: string;
    /**
     *
     * @type {string}
     * @memberof RecentHotel
     */
    heroImage?: string;
    /**
     *
     * @type {string}
     * @memberof RecentHotel
     */
    chainName?: string;
    /**
     *
     * @type {string}
     * @memberof RecentHotel
     */
    checkin: string;
    /**
     *
     * @type {string}
     * @memberof RecentHotel
     */
    checkout: string;
    /**
     *
     * @type {number}
     * @memberof RecentHotel
     */
    numberOfAdults: number;
    /**
     *
     * @type {Array<number>}
     * @memberof RecentHotel
     */
    childrenAges: Array<number>;
    /**
     *
     * @type {string}
     * @memberof RecentHotel
     */
    searchSessionId?: string;
    /**
     *
     * @type {Date}
     * @memberof RecentHotel
     */
    lastViewedAt: Date;
}

/**
 * Check if a given object implements the RecentHotel interface.
 */
export function instanceOfRecentHotel(value: object): value is RecentHotel {
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('propertyName' in value) || value['propertyName'] === undefined) return false;
    if (!('checkin' in value) || value['checkin'] === undefined) return false;
    if (!('checkout' in value) || value['checkout'] === undefined) return false;
    if (!('numberOfAdults' in value) || value['numberOfAdults'] === undefined) return false;
    if (!('childrenAges' in value) || value['childrenAges'] === undefined) return false;
    if (!('lastViewedAt' in value) || value['lastViewedAt'] === undefined) return false;
    return true;
}

export function RecentHotelFromJSON(json: any): RecentHotel {
    return RecentHotelFromJSONTyped(json, false);
}

export function RecentHotelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentHotel {
    if (json == null) {
        return json;
    }
    return {

        'propertyId': json['property_id'],
        'propertyName': json['property_name'],
        'propertyAddress': json['property_address'] == null ? undefined : json['property_address'],
        'heroImage': json['hero_image'] == null ? undefined : json['hero_image'],
        'chainName': json['chain_name'] == null ? undefined : json['chain_name'],
        'checkin': json['checkin'],
        'checkout': json['checkout'],
        'numberOfAdults': json['number_of_adults'],
        'childrenAges': json['children_ages'],
        'searchSessionId': json['search_session_id'] == null ? undefined : json['search_session_id'],
        'lastViewedAt': (new Date(json['last_viewed_at'])),
    };
}

export function RecentHotelToJSON(json: any): RecentHotel {
    return RecentHotelToJSONTyped(json, false);
}

export function RecentHotelToJSONTyped(value?: RecentHotel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'property_id': value['propertyId'],
        'property_name': value['propertyName'],
        'property_address': value['propertyAddress'],
        'hero_image': value['heroImage'],
        'chain_name': value['chainName'],
        'checkin': value['checkin'],
        'checkout': value['checkout'],
        'number_of_adults': value['numberOfAdults'],
        'children_ages': value['childrenAges'],
        'search_session_id': value['searchSessionId'],
        'last_viewed_at': value['lastViewedAt'].toISOString(),
    };
}
